import React from "react";
import { Form, Row, Col } from "react-bootstrap";

import "./Forms.css";
import InputError from "../../InputError/InputError";

function TextField({
  required = false,
  type,
  formLabel,
  size,
  placeholder,
  name,
  value,
  onChange,
  isError,
  disabled,
  errorMessage = "",
}) {
  // const numericRegExp = /^-?\d*\.?\d*$/;
  // const numericRegExp = /^-?\d*\.?\d*$/;

  // const handleInputChange = (event) => {
  //   const inputValue = event.target.value;

  //   // Check if the input matches the numeric pattern before updating the state
  //   if (inputValue.match("^d+(.d+)?$") || inputValue === "") {
  //     onChange(event);
  //   }
  // };
  return (
    <Form>
      {type === "inline" ? (
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Row>
            <Col sm={4}>
              <Form.Label className="form-label align-left">
                {formLabel}
                {required && <span className="badge">*</span>}
              </Form.Label>
            </Col>
            <Col sm={6}>
              <Form.Control
                type="text"
                placeholder={placeholder}
                size={size}
                name={name}
                value={value}
                // onChange={handleInputChange}
                onChange={onChange}
                disabled={disabled}
                // pattern="-?\d*\.?\d*"
                // onKeyPress={(event) => {
                //   if (!/[\d\-]/.test(event.key)) {
                //     event.preventDefault();
                //   }
                // }}
              />
              <InputError
                isValid={isError}
                message={
                  errorMessage !== "" ? errorMessage : "This field is required"
                }
              />
            </Col>
          </Row>
        </Form.Group>
      ) : (
        <>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="align-left form-label">
              {formLabel}
              {required && <span className="badge">*</span>}
            </Form.Label>
            <Form.Control
              type="text"
              placeholder={placeholder}
              size={size}
              name={name}
              value={value}
              // onChange={handleInputChange}
              onChange={onChange}
              disabled={disabled}
              // pattern="-?\d*\.?\d*"
              // onKeyPress={(event) => {
              //   if (!/[\d\-]/.test(event.key)) {
              //     event.preventDefault();
              //   }
              // }}
            />
            <InputError
              isValid={isError}
              message={
                errorMessage !== "" ? errorMessage : "This field is required"
              }
            />
          </Form.Group>
        </>
      )}
    </Form>
  );
}

export default TextField;
